import BasicModal from '../../../../components/action-modal';
import { PublicKBFolderProps } from '../kb.props';

function PublicKBFolder({ open, handleCancelClick, handleShareFolder }: PublicKBFolderProps) {
  return (
    <BasicModal
      className="w-[400px]"
      open={open}
      resetData={handleCancelClick}
      confirmButtonText="Confirm"
      saveData={handleShareFolder}
    >
      <span className="font-semibold text-center pb-3">
        {`Are you sure you want to share this asset with others? Once it's shared, the action can't be reversed.`}
      </span>
    </BasicModal>
  );
}

export default PublicKBFolder;
